export const inspections = [
    "test 1",
    "test 2",
    "test 3"
];